import { motion } from "framer-motion";
import { ShieldCheck, UserCheck, BookOpen, Flag } from "lucide-react";

const PILLARS = [
  {
    icon: ShieldCheck,
    title: "Age & Identity Verification",
    body: "Every provider completes third-party age and identity verification before a profile is published. Clients verify 18+ through facial age estimation or ID — including methods that never disclose identity.",
  },
  {
    icon: UserCheck,
    title: "Dedicated Review Team",
    body: "Human reviewers vet every profile, photograph, and listing against our Advertising & Content Standards before anything goes live.",
  },
  {
    icon: BookOpen,
    title: "Community Guidelines",
    body: "A strict Code of Conduct governs every interaction — zero tolerance for minors, trafficking, exploitation, coercion, or harassment.",
  },
  {
    icon: Flag,
    title: "Member Reporting System",
    body: "Any member can flag content or conduct in one tap. Reports route directly to our trust & safety team for review and action.",
  },
];

export default function TrustStandards() {
  return (
    <section id="standards" data-testid="standards-section" className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-24 lg:py-32">
      <motion.div
        className="mb-16"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <p className="text-xs uppercase tracking-[0.35em] text-gold/80 mb-4">Trust & Safety</p>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light text-amber-100/95 max-w-2xl">
          Luxury without standards is <span className="italic gold-text">just noise</span>
        </h2>
      </motion.div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {PILLARS.map((p, i) => (
          <motion.div
            key={p.title}
            data-testid={`pillar-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="p-8 bg-onyx border hairline-gold card-glow transition-all duration-500"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
          >
            <p.icon size={26} strokeWidth={1.25} className="text-gold mb-6" />
            <h3 className="font-serif text-xl text-amber-100/90 mb-3">{p.title}</h3>
            <p className="text-sm text-neutral-400 font-light leading-relaxed">{p.body}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
